module.exports = __webpack_public_path__ + "media/images/mypage/mymenu_2_ov-4022b55e497e8b4a747612e867f79926.gif";